/* eslint-disable
    prefer-const
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS201: Simplify complex destructure assignments
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import * as analytics from 'analytics/Analytics';
import classNames from 'classnames';
import {ANALYTICS_MODULE} from 'constants/AnalyticsConstants';
import reactUpdate from 'immutability-helper';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';
import * as util from 'biojs/Util';
import Enzymes from 'molbio/enzymes/backbone/Enzymes';
import * as AssemblyConstants from 'constants/AssemblyConstants';
import getTestProps from 'test/lib/cypress/getTestProps';

const {ASSEMBLY_TYPE} = AssemblyConstants;

import EnzymeConstants from 'molbio/enzymes/EnzymeConstants';

const {TYPE_IIS_ENZYME_IDS} = EnzymeConstants;

import notifications from 'notifications';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import Tooltip from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import PopoverIcon from 'ui-library/PopoverIcon';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';

const COMMON_ENZYMES = Enzymes.getCommonEnzymes();
const ASSEMBLY_NAME_MAX_LENGTH = 128; // Should match server.

const UPDATE_PARAMETER_PROP_TYPES = {
  model: PropTypes.object.isRequired,
  showParameters: PropTypes.bool.isRequired,
  updateParameters: PropTypes.func.isRequired,
  toggleParameters: PropTypes.func.isRequired,
};

class UpdateParameterComponent extends React.Component {
  static propTypes = {
    ...UPDATE_PARAMETER_PROP_TYPES,
    parameters: PropTypes.object.isRequired,
    renderParametersForm: PropTypes.func.isRequired,
  };

  // Because we need to support invalid state (i.e. while typing out a number), we copy the parameters to
  // localParameters (fields are rendered off localParameters) and selectively update server parameters.
  state = {
    localParameters: this.props.model.parameters(),
  };

  // Override local parameters with model parameters always.
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({localParameters: nextProps.model.parameters()});
  }

  renderParameters() {
    if (!this.props.showParameters) {
      return null;
    }
    return (
      <div className="assembly-settings">
        {this.props.renderParametersForm({
          renderInput: this.renderInput,
          parameterUpdater: this.parameterUpdater,
          updateParameterByValue: this.updateParameterByValue,
          localParameters: this.state.localParameters,
        })}
      </div>
    );
  }

  renderInput = ({key, onChange}) => {
    const value = this.state.localParameters[key];
    const valid = this.serverValid([key, value]);
    return (
      <span className={classNames({'has-error': !valid})}>
        <input type="text" onChange={onChange} value={value} className="form-control" />
      </span>
    );
  };

  serverValid = (...args) => {
    const [key, value] = Array.from(args[0]);
    const {number, nullable} = this.props.parameters[key];
    if (value == null) {
      return nullable;
    }
    if (number) {
      return value.toString().length > 0;
    }
    return true;
  };

  parameterUpdater = (key, cast) => (e) => this.updateParameterByValue(key, cast, e.target.value);

  // Returns new parameters if parameter was valid, null otherwise.
  updateParameterByValue = (key, cast, value, options) => {
    if (options == null) {
      options = {};
    }
    _.defaults(options, {save: true, existingParams: null});
    let {save, existingParams} = options;
    if (existingParams == null) {
      existingParams = this.state.localParameters;
    }

    // We use Number() for stricter casting, so '1abc' doesn't cast to '1'
    if (value.length && (cast === parseInt || cast === parseFloat) && Number.isNaN(cast(Number(value)))) {
      return null;
    }
    // Need to remove trailing '.' for ints
    if (value.length && cast === parseInt) {
      value = cast(Number(value));
    }
    const newParams = reactUpdate(existingParams, {$merge: _.object([[key, value]])});
    this.setState({localParameters: newParams});
    if (save && _.all(_.pairs(newParams), this.serverValid)) {
      this.props.updateParameters(newParams);
    }
    return newParams;
  };

  render = () => <FinalizeWrapper {...this.props}>{this.renderParameters()}</FinalizeWrapper>;
}

class FinalizeWrapper extends React.Component {
  static propTypes = {
    toggleParameters: PropTypes.func,
    showParameters: PropTypes.bool.isRequired,
    model: PropTypes.object.isRequired,
    createAssembly: PropTypes.func.isRequired,
    deleteAssembly: PropTypes.func.isRequired,
    children: PropTypes.node,
  };

  handleClickAssemble = () => {
    analytics.track('assembly', 'assemble_click', {
      product: ANALYTICS_MODULE.MOLBIO,
      assemblyMethod: this.props.model.method(),
    });
    this.props.createAssembly();
  };

  setName = (e) => {
    let name = e.target.value;
    if (name.length > ASSEMBLY_NAME_MAX_LENGTH) {
      name = name.slice(0, ASSEMBLY_NAME_MAX_LENGTH);
      notifications.warn(`Assembly names can't be more than ${ASSEMBLY_NAME_MAX_LENGTH} characters.`, {
        id: 'assembly-name',
      });
    }
    this.props.model.set({name});
  };

  render() {
    return (
      <div className="assembly-finalize u-small-spacing-left">
        <div>
          <div className="input-group u-small-spacing-bottom">
            <input
              type="text"
              placeholder="Assembly Name"
              value={this.props.model.name()}
              onChange={this.setName}
              className="u-small-spacing-bottom"
              {...getTestProps({component: 'FinalizeWrapper', element: 'input'})}
            />
            <div
              className={classNames({
                // Bring back rounded borders if all three buttons aren't present
                buttonGroup: this.props.toggleParameters != null,
              })}
            >
              <Tooltip title="Delete Assembly" container=".assembly-finalize">
                <Button
                  buttonStyle={ButtonStyle.TERTIARY_GRAY}
                  size={ButtonSize.SMALL}
                  onClick={this.props.deleteAssembly}
                  icon="format-delete"
                />
              </Tooltip>
              <Tooltip title="Enzyme / Primer Settings" container=".assembly-finalize">
                <Button
                  buttonStyle={ButtonStyle.TERTIARY_GRAY}
                  size={ButtonSize.SMALL}
                  onClick={this.props.toggleParameters}
                  className={classNames({
                    'is-active': this.props.showParameters,
                    invisible: this.props.toggleParameters == null,
                  })}
                  icon="settings"
                />
              </Tooltip>
              <Button
                buttonStyle={ButtonStyle.PRIMARY}
                size={ButtonSize.SMALL}
                disabled={!this.props.model.canCreate() || this.props.model.name().length === 0}
                onClick={this.handleClickAssemble}
                text="Assemble"
                dataTestAttrs={{component: 'FinalizeWrapper', element: 'assembleButton'}}
              />
            </div>
          </div>
        </div>
        {this.props.children}
      </div>
    );
  }
}

const DigestFinalize = (props) => (
  // eslint-disable-next-line no-restricted-syntax
  <FinalizeWrapper {..._.extend({}, props, {toggleParameters: null})} />
);

const gibsonParameters = {
  tmAnneal: {number: true, nullable: false},
  tmWhole: {number: true, nullable: false},
  tmDiff: {number: true, nullable: false},
  minOverlap: {number: true, nullable: false},
  maxOverlap: {number: true, nullable: false},
};

const renderGibsonForm = ({renderInput, parameterUpdater}) => (
  <Row>
    <Col sm={6}>
      <Row>
        <Col sm={8}>
          Min T<sub>m</sub>
          {" for primer's binding bases"}
        </Col>
        <Col sm={4}>
          {renderInput({
            key: 'tmAnneal',
            onChange: parameterUpdater('tmAnneal', parseFloat),
          })}
          {' \u00B0C'}
        </Col>
      </Row>
      <Row>
        <Col sm={8}>
          Min T<sub>m</sub>
          {' for whole primer'}
        </Col>
        <Col sm={4}>
          {renderInput({
            key: 'tmWhole',
            onChange: parameterUpdater('tmWhole', parseFloat),
          })}
          {' \u00B0C'}
        </Col>
      </Row>
    </Col>
    <Col sm={6}>
      <Row>
        <Col sm={8}>
          Max T<sub>m</sub>
          {' diff for primer pairs'}
        </Col>
        <Col sm={4}>
          {renderInput({
            key: 'tmDiff',
            onChange: parameterUpdater('tmDiff', parseFloat),
          })}
          {' \u00B0C'}
        </Col>
      </Row>
      <Row>
        <Col sm={8}>Length of homology/binding regions</Col>
        <Col sm={4}>
          {renderInput({
            key: 'minOverlap',
            onChange: parameterUpdater('minOverlap', parseInt),
          })}
          {' - '}
          {renderInput({
            key: 'maxOverlap',
            onChange: parameterUpdater('maxOverlap', parseInt),
          })}
          {' bp'}
        </Col>
      </Row>
    </Col>
  </Row>
);

const GibsonFinalize = (props) => (
  <UpdateParameterComponent
    {...props}
    parameters={gibsonParameters}
    renderParametersForm={renderGibsonForm}
  />
);

GibsonFinalize.propTypes = UPDATE_PARAMETER_PROP_TYPES;

const goldenGateParameters = {
  preRecognitionSiteLength: {number: true, nullable: false},
  preRecognitionSiteBases: {number: false, nullable: true},
  bindingRegionMinTM: {number: true, nullable: false},
  bindingRegionMinLength: {number: true, nullable: false},
  primerPairMaxTMDiff: {number: true, nullable: false},
  enzymeID: {number: true, nullable: false},
};

function GoldenGateFinalize(props) {
  const renderForm = ({renderInput, parameterUpdater, updateParameterByValue, localParameters}) => {
    // Clear out preRecognitionSiteBases when length changes.
    const updatePreRecogLength = (e) => {
      const newParams = updateParameterByValue('preRecognitionSiteLength', parseInt, e.target.value, {
        save: false,
      });
      const bases = props.model.parameters().preRecognitionSiteBases;
      if (
        !newParams ||
        e.target.value.length === 0 ||
        newParams.preRecognitionSiteLength === (bases != null ? bases.length : undefined)
      ) {
        return;
      }
      updateParameterByValue('preRecognitionSiteBases', _.identity, '', {existingParams: newParams});
    };

    // Update preRecognitionSiteLength when bases change.
    const updatePreRecogBases = (e) => {
      const bases = util.sanitize(e.target.value, util.NucleotideType.DNA).toUpperCase();
      const newParams = updateParameterByValue('preRecognitionSiteBases', _.identity, bases, {
        save: false,
      });
      if (!newParams || bases.length === 0) {
        return;
      }
      updateParameterByValue('preRecognitionSiteLength', parseInt, bases.length, {
        existingParams: newParams,
      });
    };

    let enzymeID;
    return (
      <Row>
        <Col sm={4}>
          <Row>
            <Col sm={6}>Pre-recognition site length</Col>
            <Col sm={6}>
              {renderInput({
                key: 'preRecognitionSiteLength',
                onChange: updatePreRecogLength,
              })}
              {' bp'}
            </Col>
          </Row>
          <Row>
            {/* space used in between glyphicon */}
            <Col sm={6}>
              {'Pre-recognition site bases '}
              <PopoverIcon
                renderContent={() =>
                  "These bases will be included before the enzyme recognition site in each primer's overhang. If they are not specified, a random string of bases will be used."
                }
                placement={FloatingPlacement.TOP}
                icon="circle-question"
              />
            </Col>
            <Col sm={6}>
              {renderInput({
                key: 'preRecognitionSiteBases',
                onChange: updatePreRecogBases,
              })}
            </Col>
          </Row>
        </Col>
        <Col sm={4}>
          <Row>
            <Col sm={6}>
              Min T<sub>m</sub>
              {' for binding region'}
            </Col>
            <Col sm={6}>
              {renderInput({
                key: 'bindingRegionMinTM',
                onChange: parameterUpdater('bindingRegionMinTM', parseFloat),
              })}
              {' \u00B0C'}
            </Col>
          </Row>
          <Row>
            <Col sm={6}>Min length for binding region</Col>
            <Col sm={6}>
              {renderInput({
                key: 'bindingRegionMinLength',
                onChange: parameterUpdater('bindingRegionMinLength', parseInt),
              })}
              {' bp'}
            </Col>
          </Row>
        </Col>
        <Col sm={4}>
          <Row>
            <Col sm={6}>
              Max T<sub>m</sub>
              {' diff for primer pairs'}
            </Col>
            <Col sm={6}>
              {renderInput({
                key: 'primerPairMaxTMDiff',
                onChange: parameterUpdater('primerPairMaxTMDiff', parseFloat),
              })}
              {' \u00B0C'}
            </Col>
          </Row>
          <Row>
            <Col sm={6}>Type IIS Enzyme</Col>
            <Col sm={6}>
              <select onChange={parameterUpdater('enzymeID', parseInt)} value={localParameters.enzymeID}>
                {(() => {
                  const result = [];
                  for (enzymeID of Array.from(TYPE_IIS_ENZYME_IDS)) {
                    result.push(
                      <option value={enzymeID} key={`enzyme-choice-${enzymeID}`}>
                        {COMMON_ENZYMES.get(enzymeID).get('name')}
                      </option>
                    );
                  }
                  return result;
                })()}
              </select>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  };

  return (
    <UpdateParameterComponent
      {...props}
      parameters={goldenGateParameters}
      renderParametersForm={renderForm}
    />
  );
}

GoldenGateFinalize.propTypes = {...UPDATE_PARAMETER_PROP_TYPES, model: PropTypes.object.isRequired};

function for_(assembly, props) {
  const component = (() => {
    switch (assembly.method()) {
      case ASSEMBLY_TYPE.DIGEST:
        return DigestFinalize;
      case ASSEMBLY_TYPE.GIBSON:
        return GibsonFinalize;
      case ASSEMBLY_TYPE.GOLDEN_GATE:
        return GoldenGateFinalize;
      default:
        throw new Error(`Unexpected assembly method: ${assembly.method()}`);
    }
  })();

  // eslint-disable-next-line no-restricted-syntax
  return React.createElement(component, _.extend({model: assembly}, props));
}

export default {
  for: for_,
};
